'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
var styledBreakpoint = require('../hocs/styledBreakpoint.js');
var gridGutterRow = require('../hocs/gridGutterRow.js');
var gridRow = require('../hocs/gridRow.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const {
  component
} = styledBreakpoint["default"]()(gridGutterRow["default"]()(gridRow["default"]()(styled__default["default"].div.withConfig({
  componentId: "sc-1bp5yri-0"
})([""]))));

exports["default"] = component;
